import { useSearchParams } from 'react-router-dom';
import { useUrlOverrides } from '@/services/urlOverrides/useUrlOverrides';
import { useGetCartsDataQuery } from '@/api/carts/getCartsData';

function UrlOverridesContainer({ children }: React.PropsWithChildren) {
  const [searchParams] = useSearchParams();
  const environmentParam = searchParams.get('environment');

  const { data: cartsLoadData  } = useGetCartsDataQuery({
    environment: environmentParam ?? 'master'
  });

  // Persist all query strings (if set) to urlOverrides state, and pass in
  // carts data to handle A-B functionality within the associated reducer
  useUrlOverrides(cartsLoadData?.data);

  return children;
}

export default UrlOverridesContainer;
